import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { useParams } from "react-router";
import ContentfulPage from "../../ContentfulPage";
import { HomeMenu } from "views/UIelems/v2/Header/HomeMenu";
import { PAGE_IDS } from "../../constants";
const TreatmentPageWrapper = ({ slug, contentTag = PAGE_IDS.TREATMENT }) => {
    const { page_slug } = useParams();
    const rawSlug = slug || page_slug || "";
    const identifier = rawSlug.startsWith("treatment-") ? rawSlug : `treatment-${rawSlug}`;
    return (_jsxs(_Fragment, { children: [_jsx(HomeMenu, {}), _jsx(ContentfulPage, { contentTag: contentTag, identifier: identifier, isStatic: false })] }));
};
export default TreatmentPageWrapper;
